const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';

export const COMPANY_NAME = 'Ahmed Corporation';

export { API_BASE_URL };
